import './index.css'

const SuggestionItem = props => {
  const {suggestionDetails, onSuggestionClick} = props
  const {suggestion} = suggestionDetails

  const handleClick = () => {
    onSuggestionClick(suggestion)
  }

  return (
    <li className="suggestion-item">
      <p className="suggestion-text">{suggestion}</p>
      <img
        src="https://assets.ccbp.in/frontend/react-js/diagonal-arrow-left-up.png"
        alt="arrow"
        className="arrow-icon"
        onClick={handleClick}
      />
    </li>
  )
}

export default SuggestionItem
